



























































































































































































































































import Vue from 'vue';

import { iconsMixin } from '@/mixins/icons';
import { breakpointsMixin } from '@/mixins/breakpoints';
import { authMixin } from '@/mixins/auth';
import { formatMixin } from '@/mixins/format';

import carrierService from '@/services/CarrierService';
import ediService from '@/services/EdiService';
import accountsService from '@/services/AccountsService';
import localStorageService from '@/services/LocalStorageService';
import miscService from '@/services/MiscService';

import DropdownOption from '@/models/misc/DropdownOption';
import EdiLinkLookup from '@/models/edi/EdiLinkLookup';
import { Account } from '@/models/Account';
import { Carrier } from '@/models/carriers/Carrier';

export default Vue.extend<any, any, any, any>({
  mixins: [iconsMixin, breakpointsMixin, authMixin, formatMixin],
  data() {
    return {
      effectiveDate: null,
      senderId: '',
      receiverId: '',
      accountsDdl: [] as DropdownOption[],
      selectedAccount: null,
      carriersDdl: [] as DropdownOption[],
      selectedCarrier: null,
      selectedEdiTypes: [],
      loading: false,
      saving: false,
      snackbar: false,
      snackbarText: '',
      snackbarError: false,
      snackbarErrorText: '',
      loadingMessage: '',
      ediTypes: [
        {
          id: 204,
          code: 'EDI-204',
          desc: 'Automatically send a pickup request to the carrier once the shipment has been booked.',
        },
        {
          id: 997,
          code: 'EDI-997',
          desc: 'Automatically send an acknowledgment statement to the client when the carrier accepts the pickup request & pickup location.',
        },
        {
          id: 214,
          code: 'EDI-214',
          desc: 'Automatically send client shipment status updates and location stamps while en route.',
        },
      ],
      ediTypesHeaders: [
        {
          text: '',
          value: 'id',
          sortable: false,
        },
        {
          text: 'EDI Code',
          value: 'code',
          sortable: false,
          width: '120px',
        },
        {
          text: 'EDI Description',
          value: 'desc',
          sortable: false,
        },
      ],
      displayPopup: false,
      ediBatchToEdit: null as EdiLinkLookup, // in case of edit
      gridIndex: 0,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.loadingMessage = 'Loading details';
      this.loading = true;

      const accounts = accountsService.getAllAccounts().then((x: Account[]) => {
        this.accountsDdl = x.map(this.mapAccount);
        this.accountsDdl = x.map(this.mapAccount);
        this.accounts = x;
      });

      const availableCarriers = carrierService
        .getAllActive()
        .then((x: Carrier[]) => {
          this.carriersDdl = x.filter((p) => p.name?.length);
        });

      Promise.all([accounts, availableCarriers]).then(() => {
        if (this.isEdit) {
          this.setFieldsForEdit();
        }

        this.loading = false;
      });
    },
    mapAccount(account: Account) {
      return new DropdownOption(account.company, account.accountId);
    },
    setFieldsForEdit() {
      this.ediBatchToEdit = localStorageService.get('edi-tracking-link');
      if (this.ediBatchToEdit) {
        this.selectedCarrier = this.carriersDdl.find(
          (x) => x.mapId == this.ediBatchToEdit.carrierIdMap
        );

        this.selectedAccount = this.accountsDdl.find(
          (x) => x.value == this.ediBatchToEdit.clientId
        );

        this.receiverId = this.ediBatchToEdit.receiverId;
        this.senderId = this.ediBatchToEdit.senderId;

        if (this.ediBatchToEdit.codes.includes('204')) {
          this.selectedEdiTypes.push(204);
          this.ediTypes[0].selected = true;
        }

        if (this.ediBatchToEdit.codes.includes('997')) {
          this.selectedEdiTypes.push(997);
          this.ediTypes[1].selected = true;
        }

        if (this.ediBatchToEdit.codes.includes('214')) {
          this.selectedEdiTypes.push(214);
          this.ediTypes[2].selected = true;
        }

        this.gridIndex++;
      }
    },
    onEdiTypeSelect(type) {
      if (type.selected) {
        this.selectedEdiTypes.push(type.id);
      } else {
        this.selectedEdiTypes = this.selectedEdiTypes.filter(
          (x) => x != type.id
        );
      }
    },
    showConfirm() {
      this.displayPopup = true;
    },
    backTo() {
      window.history.back();
    },
    submitForm() {
      if (!this.formValid) return;

      const request = {};
      request['ediIds'] = null;
      if (this.isEdit) {
        request['ediIds'] = this.ediIds;
      }
      request['senderId'] = this.senderId;
      request['receiverId'] = this.receiverId;
      request['accountId'] = this.selectedAccount?.value;
      request['carrierId'] = this.selectedCarrier?.mapId;
      request['edi204'] = this.selectedEdiTypes.find((x) => x == 204) != null;
      request['edi997'] = this.selectedEdiTypes.find((x) => x == 997) != null;
      request['edi214'] = this.selectedEdiTypes.find((x) => x == 214) != null;
      request['effectiveDate'] = this.effectiveDate;

      this.saving = true;

      ediService.saveEdiLink(request).then((x) => {
        this.saving = false;
        this.displayPopup = false;
        if (!x) {
          this.snackbarError = true;
          this.snackbarErrorText = 'Error saving EDI Tracking Link';
        } else {
          this.snackbar = true;
          this.snackbarText = 'EDI Tracking Link saved successfully';

          miscService.goToPageWithDelay('/admin/edi', 3000);
        }
      });
    },
  },
  computed: {
    emptyFields() {
      const emptyFields = [];

      if (!this.selectedCarrier) emptyFields.push('Carrier Name');
      if (!this.senderId) emptyFields.push('Sender ID');
      if (!this.receiverId) emptyFields.push('Receiver ID');
      if (!this.selectedAccount) emptyFields.push('Client Name');
      if (!this.effectiveDate) emptyFields.push('Effective Date');

      const edi204 = this.selectedEdiTypes.find((x) => x == 204) != null;
      const edi997 = this.selectedEdiTypes.find((x) => x == 997) != null;
      const edi214 = this.selectedEdiTypes.find((x) => x == 214) != null;
      if (!edi204 && !edi997 && !edi214) emptyFields.push('EDI Type');

      return emptyFields.join(', ');
    },
    formValid() {
      return !this.emptyFields;
    },
    isEdit() {
      return this.$route.params.ediIds && window.location.href.includes('edit');
    },
    ediIds() {
      return this.$route.params.ediIds;
    },
    pageHeader() {
      if (this.isEdit) {
        return 'Edit EDI Tracking Link';
      }

      return 'Create New EDI Tracking Link';
    },
    pagingLength() {
      return Math.ceil(this.carrierContractsToShow.length / this.pageSize);
    },
  },
});
